import {PixelRatio, TextStyle, ViewStyle} from 'react-native';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import Styles from 'src/components/Styles';

const {subHeaderFontSize, bodyTinyFontSize, bodyFontSize} =
  getLayoutDescriber();

export function redemptionDetailStyle(): {
  container: ViewStyle;
  date: ViewStyle | TextStyle;
  content: ViewStyle;
  dashStyle: ViewStyle;
  location: TextStyle;
  row: ViewStyle;
  textLabel: ViewStyle;
  trans: TextStyle;
  largeLabel: TextStyle;
  total: ViewStyle | TextStyle;
} {
  return {
    container: {
      backgroundColor: Styles.white,
      flex: 1,
      padding: Styles.Spacing.m3,
    },
    date: {
      marginBottom: Styles.Spacing.m3,
      fontSize: bodyTinyFontSize(),
    },
    content: {
      flex: 1,
      marginBottom: Styles.Spacing.m5,
      paddingLeft: Styles.Spacing.m2,
      paddingRight: Styles.Spacing.m2,
      paddingVertical: 32,
    },
    dashStyle: {
      marginBottom: Styles.Spacing.m2,
      borderRadius: 100,
      overflow: 'hidden',
      height: PixelRatio.roundToNearestPixel(2),
      width: '100%',
      marginTop: Styles.Spacing.m2,
    },
    location: {
      fontSize: bodyFontSize(),
    },
    row: {
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'row',
    },
    textLabel: {
      flex: 1,
    },
    trans: {
      fontSize: bodyTinyFontSize(),
      color: Styles.lightGray,
    },
    largeLabel: {
      fontSize: Styles.Fonts.f1,
    },
    total: {
      marginTop: -1 * Styles.Spacing.m1,
      marginBottom: Styles.Spacing.m1,
      color: Styles.black,
      fontSize: subHeaderFontSize(),
      fontWeight: 'bold',
    },
  };
}

export default {
  redemptionDetailStyle,
};
